export default {
  announcementFields: [
    {
      name: "startTime",
      order: 1,
      title: "起始時間",
      show: true,
      __typename: "announcementField"
    },
    {
      name: "title",
      order: 2,
      title: "公告名稱",
      show: true,
      __typename: "announcementField"
    },
    {
      name: "content",
      order: 3,
      title: "公告內容",
      show: true,
      __typename: "announcementField"
    },
    {
      name: "type",
      order: 4,
      title: "類型",
      show: true,
      __typename: "announcementField"
    },
    {
      name: "isNotificationAssistant",
      order: 5,
      title: "通知業務",
      show: true,
      __typename: "announcementField"
    },
    {
      name: "creator",
      order: 6,
      title: "發送者",
      show: true,
      __typename: "announcementField"
    }
  ]
}
